var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<md-dialog aria-label=\"Edit Menu in Group\"><md-toolbar layout-padding=\"layout-padding\"><div class=\"md-tooolbar-tools\"><h4>{{vm.dialogOptions.headerText}}</h4></div></md-toolbar><md layout-padding=\"layout-padding\" class=\"dialog-content\"><div style=\"min-width: 600px\"><form name=\"addDocPartForm\" class=\"form-horizontal\"><div ng-class=\"{'has-error': vm.validationError.errors['referenceName'].kind }\" class=\"form-group\"><label for=\"referenceName\" class=\"col-sm-3 control-label\">Address 1</label><div class=\"col-sm-9\"><input name=\"referenceName\" ng-model=\"vm.item.referenceName\" placeholder=\"URL reference\" class=\"form-control\"/><span id=\"referenceName-helpBlock\" ng-show=\"vm.validationError.errors['referenceName'].kind\" class=\"help-block\">{{vm.validationError.errors['referenceName'].message}}</span></div></div></form></div></md><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.cancel()\">Cancel</md-button><md-button ng-click=\"vm.addDocPart()\">OK</md-button></md-dialog-actions></md-dialog>");;return buf.join("");
}

module.exports = module.exports.apply(module, [])


//////////////////
// WEBPACK FOOTER
// ./~/apply-loader!./app/features/production/menugroups/editMenuInGroup.jade
// module id = 233
// module chunks = 0